import { DealVersionSelector, Deal } from '../../types/deal.types';
import { DefaultDealVersion } from '../../types/casa-settings.types';

export function getDealType(deal: Deal): string {
  let version: DealVersionSelector;

  if (deal.published) {
    version = DealVersionSelector.published;
  } else if (deal.working) {
    version = DealVersionSelector.working;
  } else if (deal.public) {
    version = DealVersionSelector.public;
  }

  return (
    deal[version] &&
    deal[version].dealType &&
    deal[version].dealType.toLocaleLowerCase()
  );
}

export function getDefaultDealVersion(
  deal: Deal,
  defaultVersions: DefaultDealVersion
) {
  return defaultVersions[getDealType(deal)];
}
